import { render, staticRenderFns } from "./material-selection-dialog.vue?vue&type=template&id=5dcd0a3a&"
import script from "./material-selection-dialog.vue?vue&type=script&lang=js&"
export * from "./material-selection-dialog.vue?vue&type=script&lang=js&"
import style0 from "./material-selection-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports